export default {
  0: '指定なし',
  1: '誕生日・記念日',
  2: 'デート',
  3: '接待',
  4: '歓迎会',
  5: '送別会',
  6: '同窓会',
  7: '忘年会',
  8: '新年会',
  9: '結婚式2次会',
  10: '法事',
  11: '食事',
  12: '飲み会',
  13: '合コン',
  14: '旅行',
  15: 'その他お祝い事',
  99: 'その他',
}
